import { registerQuery, useQuery } from 'data-fetching-client';
import apiClient from 'hub-http/clients/apiClient';
import { handleError } from '../../utils/errorHandling';
import { useQuerySelector } from '../useQuerySelector';
export const FETCH_LOCALES = registerQuery({
  fieldName: 'localesResponse',
  args: [],
  fetcher: () => apiClient.get('hub-locales/v2/i18n').catch(error => {
    throw handleError(error);
  })
});
export const useFetchLocales = options => useQuery(FETCH_LOCALES, options);
export const useLocales = () => useQuerySelector(useFetchLocales(), data => data === null || data === void 0 ? void 0 : data.localesResponse);